import {
  Box,
  Button,
  ButtonProps,
  Checkbox,
  Container,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  styled,
  Tab,
  Tabs,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import LargeCard from "../../../Shared-ui/SharedComponents/Cards/LargeCard";
import TabPanel, {
  a11yProps,
} from "../../../Shared-ui/SharedComponents/TabPanel";
import Features from "./features";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));

const paginationModel = { page: 0, pageSize: 5 };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "1 Chatbot",
  "Up to 10M upload characters",
  "Access to GPT-4o mini AI model",
  "2 Data sources",
  "3 Chatbot",
  "Up to 50M upload characters",
  "Access to GPT-4o mini AI model",
  "2 Data sources",
];

const AdminSubscription = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [expanded, setExpanded] = useState<string>(""); // Track expanded panel

  const handleCancel = () => {
    setExpanded(""); // Reset expanded state
  };

  const [personName, setPersonName] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  // Vertical Tabs
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Media query to check screen size
  const isSmallDevice = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Breadcrumb data={[{ name: "Subscription", path: "" }]} />
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmallDevice ? "column" : "row", // Change layout dynamically
          height: "100%",
          gap: 4,
        }}
      >
        <Tabs
          orientation={isSmallDevice ? "horizontal" : "vertical"} // Adjust orientation dynamically
          variant="scrollable"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="Dynamic Tabs"
          textColor="primary"
          indicatorColor="primary"
          sx={{
            borderRight: isSmallDevice ? 0 : 1, // Remove border on small devices
            borderBottom: isSmallDevice ? 1 : 0, // Add bottom border on small devices
            borderColor: "divider",
            minWidth: isSmallDevice ? "100%" : "200px", // Adjust width
          }}
        >
          <Tab
            label="Plans"
            {...a11yProps(0)}
            sx={{
              textTransform: "capitalize",
              alignItems: isSmallDevice ? "center" : "flex-start",
              p: 0,
            }}
          />
          <Tab
            label="Features"
            {...a11yProps(1)}
            sx={{
              textTransform: "capitalize",
              alignItems: isSmallDevice ? "center" : "flex-start",
              p: 0,
            }}
          />
        </Tabs>
        <Box
          sx={{
            width: "100%",
          }}
        >
          <TabPanel value={tabValue} index={0}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Plans</Typography>
              <ColorButton
                variant="contained"
                disableElevation
                startIcon={<AddIcon />}
                size={isSmallScreen ? "small" : "large"}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                  borderRadius: { sm: "8px", xs: "4px" },
                  height: "40px",
                }}
                onClick={() => setExpanded("addPlan")}
              >
                Add Plan
              </ColorButton>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xl: "1fr 1fr 1fr 1fr",
                  lg: "1fr 1fr 1fr 1fr",
                  md: "1fr 1fr",
                },
                gap: 2,
                gridAutoRows: "1fr",
                mt: 3,
              }}
            >
              <Box
                sx={{
                  "& button": {
                    display: "none",
                  },
                }}
              >
                <LargeCard
                  amount={0}
                  duration="month"
                  title="Basic"
                  summary={[
                    "1 Chatbot",
                    "Up to 10M upload characters",
                    "Access to GPT-4o mini AI model",
                    "2 Data sources",
                  ]}
                  body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                  color={variables.basicColor}
                  action="Your current plan"
                />
              </Box>
              <Box
                sx={{
                  "& button": {
                    display: "none",
                  },
                }}
              >
                <LargeCard
                  amount={20}
                  duration="month"
                  title="Starter"
                  summary={[
                    "3 Chatbot",
                    "Up to 50M upload characters",
                    "Use your own LLM  API Keys",
                    "5 Data sources",
                    "Integrations",
                  ]}
                  body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                  color={variables.starterColor}
                  action="Select This Plan"
                />
              </Box>
              <Box
                sx={{
                  "& button": {
                    display: "none",
                  },
                }}
              >
                <LargeCard
                  amount={499}
                  duration="month"
                  title="Professional"
                  summary={[
                    "1 Chatbot",
                    "Up to 10M upload characters",
                    "Access to GPT-4o mini AI model",
                    "2 Data sources",
                  ]}
                  body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                  color={variables.professionalColor}
                  action="Select This Plan"
                />
              </Box>
              <Box
                sx={{
                  "& button": {
                    display: "none",
                  },
                }}
              >
                <LargeCard
                  amount="Custom Pricing"
                  //duration="month"
                  title="Enterprise"
                  summary={[
                    "1 Chatbot",
                    "Up to 10M upload characters",
                    "Access to GPT-4o mini AI model",
                    "2 Data sources",
                  ]}
                  body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                  color={variables.enterpriseColor}
                  action="Select This Plan"
                />
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">Features</Typography>
              <ColorButton
                variant="contained"
                disableElevation
                startIcon={<AddIcon />}
                size={isSmallScreen ? "small" : "large"}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                  borderRadius: { sm: "8px", xs: "4px" },
                  height: "40px",
                }}
                onClick={() => setExpanded("addFeature")}
              >
                Add Feature
              </ColorButton>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xl: "1fr 1fr 1fr",
                  lg: "1fr 1fr 1fr",
                  md: "1fr 1fr",
                },
                gap: 3,
                gridAutoRows: "1fr",
                mt: 3,
              }}
            >
              <Features featuresText="1 Chatbot" />
              <Features featuresText="Up to 10M upload characters" />
              <Features featuresText="Access to GPT-4o mini AI model" />
              <Features featuresText="2 Data sources" />
            </Box>
          </TabPanel>
        </Box>
      </Box>

      {expanded === "addPlan" && (
        <Box
          sx={{
            "&::before": {
              content: '""',
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 7,
            },
          }}
        >
          <Box
            sx={{
              width: "500px",
              display: "flex",
              flexDirection: "column",
              gap: 3,
              pt: "10px",
              position: "fixed",
              right: "0",
              top: "0",
              height: "100vh",
              background: variables.whiteColor,
              padding: "20px 30px",
              zIndex: 8,
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Add New Plan
                  </Typography>
                  <IconButton aria-label="close" onClick={handleCancel}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: 2,
                    pt: "5px",
                    height: "calc(100vh - 160px)",
                    overflow: "auto",
                  }}
                >
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Plan Name
                    </InputLabel>
                    <TextField
                      //size="small"
                      id="name"
                      name="name"
                      placeholder="Enter plan name"
                      sx={{ background: "white" }}
                    />
                  </FormControl>
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Price
                    </InputLabel>
                    <TextField
                      //size="small"
                      id="name"
                      name="name"
                      placeholder="Enter Price"
                      sx={{ background: "white" }}
                    />
                  </FormControl>
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Billing Cycle
                    </InputLabel>
                    <TextField
                      //size="small"
                      id="name"
                      name="name"
                      placeholder="Enter Billing Cycle"
                      sx={{ background: "white" }}
                    />
                  </FormControl>
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Description
                    </InputLabel>
                    <TextField
                      //size="small"
                      id="name"
                      name="name"
                      placeholder="Enter Description"
                      sx={{ background: "white" }}
                    />
                  </FormControl>
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Features
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={personName}
                      onChange={handleChange}
                      input={<OutlinedInput label="Tag" />}
                      renderValue={(selected) => selected.join(", ")}
                      MenuProps={MenuProps}
                    >
                      {names.map((name) => (
                        <MenuItem key={name} value={name}>
                          <Checkbox checked={personName.includes(name)} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: 0,
                }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={handleCancel} // Call handleCancel on click
                >
                  Cancel
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {expanded === "addFeature" && (
        <Box
          sx={{
            "&::before": {
              content: '""',
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 7,
            },
          }}
        >
          <Box
            sx={{
              width: "500px",
              display: "flex",
              flexDirection: "column",
              gap: 3,
              pt: "10px",
              position: "fixed",
              right: "0",
              top: "0",
              height: "100vh",
              background: variables.whiteColor,
              padding: "20px 30px",
              zIndex: 8,
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Add Feature
                  </Typography>
                  <IconButton aria-label="close" onClick={handleCancel}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: 2,
                    pt: "5px",
                    height: "calc(100vh - 160px)",
                    overflow: "auto",
                  }}
                >
                  <FormControl fullWidth variant="outlined" required>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Feature Name
                    </InputLabel>
                    <TextField
                      //size="small"
                      id="name"
                      name="name"
                      placeholder="Enter Feature"
                      sx={{ background: "white" }}
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: 0,
                }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={handleCancel} // Call handleCancel on click
                >
                  Cancel
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default AdminSubscription;
